import React, { CSSProperties, ReactNode } from 'react'
import styles from './DefaultButton.module.scss'

interface DefaultButtonProps {
  title: string
  onClick?: () => void
  disabled?: boolean
  backgroundColor?: string
  fontColor?: string
  borderRadius?: string
  fontSize?: number
  border?: string
  width?: string
  height?: string
  padding?: string
  buttonStyles?: CSSProperties
  leftIcon?: ReactNode
  rightIcon?: ReactNode
  inverted?: boolean
  secondary?: boolean
  outlined?: boolean
  type?: 'button' | 'submit' | 'reset'
  name?: string
  fontWeight?: string | number
  tabindex?: number
}

const DefaultButton: React.FC<DefaultButtonProps> = ({
  title,
  onClick,
  disabled,
  backgroundColor,
  fontColor,
  borderRadius,
  fontSize = 16,
  border,
  width,
  height,
  padding,
  buttonStyles,
  leftIcon,
  rightIcon,
  inverted,
  secondary,
  outlined,
  type = 'button',
  name,
  fontWeight,
  tabindex,
}) => {
  return (
    <button
      tabIndex={tabindex}
      onClick={onClick}
      className={`
        ${styles.container}
        ${secondary ? styles.secondary : ''}
        ${disabled ? styles.disabled : ''}
        ${inverted ? styles.inverted : ''}
        ${outlined ? styles.outlined : ''}
      `}
      style={{
        backgroundColor: backgroundColor,
        color: fontColor,
        borderRadius: borderRadius,
        padding: padding,
        fontSize: fontSize,
        border: border,
        width: width,
        height: height,
        ...buttonStyles,
      }}
      disabled={disabled}
      type={type}
      name={name}
    >
      {leftIcon && <div className={`${styles.icon} ${styles.leftIcon}`}>{leftIcon}</div>}
      <h4 className={styles.title} style={{ fontSize, fontWeight }}>
        {title}
      </h4>
      {rightIcon && <div className={`${styles.icon} ${styles.rightIcon}`}>{rightIcon}</div>}
    </button>
  )
}

export default DefaultButton
